<span class="svg" *ngIf="svg" [innerHTML]="svg"></span>
